import { Typography } from '@mui/material'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

const TitleTypographyAtom = (props: TypographyProps) => {
	// Props
	const { text, textAlign } = props

	return (
		<Typography
			component="h1"
			align={textAlign}
			color="#1c1c1c"
			sx={{
				fontSize: { xs: 24, md: 36 },
				fontWeight: 700,
				lineHeight: 1.25,
				letterSpacing: -0.02
			}}
		>
			{text}
		</Typography>
	)
}

export default TitleTypographyAtom
